import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/customer/project/page', data, {
    trim: true
  })
}

// 导出
export function exportExcel (data) {
  return request.post('/customer/project/exportExcel', data, {
    download: true
  })
}

// 修改
export function updateById (data) {
  return request.post('/customer/project/updateById', data)
}

// 提交
export function submit (data) {
  return request.post('/customer/project/submit', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/customer/project/delete/${id}`)
}

// 统计
export function count (data) {
  return request.post('/customer/project/count', data)
}

// 统计用户交付数
export function countUserDelivery (data) {
  return request.post('/customer/project/count/user', data)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/customer/project/delete/batch', {
    params: {
      ids
    }
  })
}
